import { StrategyDetailsPageListDocumentRecordsQuery } from '@/__generated__/graphql';
import Tag from '@/components/basicComponents/tag';
import { getManagerUpdateName, getTagStyleType } from '@/components/managerUpdates-page/utils';
import DropdownActions from '@/components/table/dropdownActions';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { IItems } from '@/components/table/types';
import { dateFormatter } from '@/shared/utils/date';
import { DocumentRecordStatus } from '@trace-8/trace8-schema';
import { format } from 'date-fns';
import styled from 'styled-components';

interface MobileTableProps {
  tableData: StrategyDetailsPageListDocumentRecordsQuery['listDocumentRecords']['records'];
  dropdownActions: (row: StrategyDetailsPageListDocumentRecordsQuery['listDocumentRecords']['records'][number]) => IItems[];
  openEditManagerUpdatePage: (updateId: string) => void;
}

const MobileTable = ({ tableData, dropdownActions, openEditManagerUpdatePage }: MobileTableProps) => {
  return (
    <MobileTableWrapper>
      {tableData?.length ? (
        <>
          {tableData.map((el) => {
            return (
              <MobileTableRowWrap key={el.id}>
                <MobileRow>
                  <MobileRowTitle>Update</MobileRowTitle>
                  <MobileRowValue onClick={() => openEditManagerUpdatePage(el.id)} isRedirect>
                    {getManagerUpdateName(el.documentRecordFieldAnswers, el.name)}
                  </MobileRowValue>
                </MobileRow>

                <MobileRow>
                  <MobileRowTitle>Owner</MobileRowTitle>
                  <MobileRowValue>{`${el?.owner?.firstName ?? ''} ${el?.owner?.lastName ?? ''}`}</MobileRowValue>
                </MobileRow>

                <MobileRow>
                  <MobileRowTitle>Date</MobileRowTitle>
                  <MobileRowValue>
                    {el.statusUpdatedAt && dateFormatter(format(new Date(el.statusUpdatedAt), 'yyyy-MM-dd'), 'yyyy-MM-dd')}
                  </MobileRowValue>
                </MobileRow>

                <MobileRow>
                  <MobileRowTitle>Status</MobileRowTitle>
                  <MobileRowValue>{DocumentRecordStatus[el.status]}</MobileRowValue>
                </MobileRow>

                <MobileRow>
                  <MobileRowTitle>Flag</MobileRowTitle>
                  <MobileRowValue>
                    {el?.sentimentFlag && el?.sentimentFlagLabel ? (
                      <Tag title={el?.sentimentFlagLabel} size="sm" styleType={getTagStyleType(el?.sentimentFlag)} />
                    ) : (
                      '--'
                    )}
                  </MobileRowValue>
                </MobileRow>

                <DropdownActionsWrapper>
                  <DropdownActions items={dropdownActions(el)} isMobile isListCenter />
                </DropdownActionsWrapper>
              </MobileTableRowWrap>
            );
          })}
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const DropdownActionsWrapper = styled.div`
  margin: 0 auto;
`;
